export class InventoryTypeFieldSearchValueMessage {
  id: number
  value: string

  constructor(id: number, value: string) {
    this.id = id
    this.value = value
  }
}